import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
// Components
import LinksMap from '../components/LinksMap'
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/my-account.css'
import '../assets/css/form.css'

export default function MyAccount(props) {
  const [accountDetails, setAccountDetails] = useState({
    firstName: 'Forhad',
    lastName: 'Hossain',
    displayName: 'forhadhossain60',
    email: 'forhadhossain60@outlook.com',
    mobileNumber: '01724904320'
  })

  const [emailChangeFormShow, setEmailChangeFormShow] = useState(false)

  return (
    <div className='my_account_page'>
      <PageTransition />
      <LinksMap linksArr={[{name: 'Home', path: '/', active: false}, {name: 'My Account', path: '/my-account', active: true}]} pageName='My Account' />

      <div className='container'>
        <div className='wrapper'>
          <div className='side_content'>
            <ul className='links'>
              <li><NavLink to='/my-account/dashboard' activeClassName='active'>Dashboard</NavLink></li>
              <li><NavLink to='/my-account/orders'>Orders</NavLink></li>
              <li><NavLink to='/my-account/addresses'>Addresses</NavLink></li>
              <li><NavLink to='/my-account/account-details'>Account Details</NavLink></li>
              <li><NavLink to='/wishlist'>Wishlist</NavLink></li>
              <li><NavLink to='/logout'>Logout</NavLink></li>
            </ul>
          </div>
          <div className='main_content'>
  
            {
              props.page === 'dashboard' ?
              <section className='dashboard'>
                <PageTransition />
                <p>Hello <span className='bold'>forhadhossain60</span> (not <span className='bold'>forhadhossain60</span>? <Link to='/logout'>Logout</Link>)</p>
                <p style={{marginTop: '20px'}}>From your account dashboard you can view your <Link to='/my-account/orders'>recent orders</Link>, manage your <Link to='/my-account/adresses'>shipping and billing addresses</Link>, and <Link to='/my-account/account-details'>edit your password and account details</Link>.</p>
    
                <div className='dashboard_links'>
                  <Link className='card' to='/my-account/orders'>
                    <div className='icon'>
                      <span className='fas fa-th'></span>
                    </div>
                    <div className='title'>Orders</div>
                  </Link>
                  <Link className='card' to='/my-account/addresses'>
                    <div className='icon'>
                      <span className='fas fa-address-card'></span>
                    </div>
                    <div className='title'>Addresses</div>
                  </Link>
                  <Link className='card' to='/my-account/account-details'>
                    <div className='icon'>
                      <span className='fas fa-user'></span>
                    </div>
                    <div className='title'>Account Details</div>
                  </Link>
                  <Link className='card' to='/wishlist'>
                    <div className='icon'>
                      <span className='fas fa-heart'></span>
                    </div>
                    <div className='title'>Wishlist</div>
                  </Link>
                  <Link className='card' to='/cart'>
                    <div className='icon'>
                      <span className='fas fa-shopping-cart'></span>
                    </div>
                    <div className='title'>Cart</div>
                  </Link>
                  <Link className='card' to='/logout'>
                    <div className='icon'>
                      <span className='fas fa-sign-out-alt'></span>
                    </div>
                    <div className='title'>Logout</div>
                  </Link>
                </div>
              </section>
              :
              props.page === 'orders' ?
              <section className='orders'>
                <PageTransition />
                <div className='section_title'><span className='fas fa-th'></span> Orders</div>
                <div className='orders_list'>
                  <div className='order_indicator order'>
                    <span className='order_id'>ORDER</span>
                    <span className='date'>DATE</span>
                    <span className='status'>STATUS</span>
                    <span className='total'>TOTAL</span>
                    <span className='actions'>ACTIONS</span>
                  </div>
                  <div className='order'>
                    <span className='order_id'>#2605</span>
                    <span className='date'>December 21, 2021</span>
                    <span className='status'>Processing</span>
                    <span className='total'>$777.00 for 3 items</span>
                    <span className='actions'><Link to='/order/1'>VIEW</Link></span>
                  </div>
                  <div className='order'>
                    <span className='order_id'>#2605</span>
                    <span className='date'>December 21, 2021</span>
                    <span className='status'>Processing</span>
                    <span className='total'>$777.00 for 3 items</span>
                    <span className='actions'><Link to='/order/1'>VIEW</Link></span>
                  </div>
                  <div className='order'>
                    <span className='order_id'>#2605</span>
                    <span className='date'>December 21, 2021</span>
                    <span className='status'>Processing</span>
                    <span className='total'>$777.00 for 3 items</span>
                    <span className='actions'><Link to='/order/1'>VIEW</Link></span>
                  </div>
                </div>
              </section>
              : 
              props.page === 'addresses' ?
              <section className='addresses'>
                <PageTransition />
                <div className='section_title'><span className='fas fa-address-card'></span> Adresses</div>
                <p>The following addresses will be used on the checkout page by default.</p>
                <div className='addresses_list'>
                  <div className='address'>
                    <div className='title'>Billing address</div>
                    <div className='infos'>
                      <span>Forhad Hossain</span>
                      <span>MangoQuiz</span>
                      <span>Patwary Bari, Meghdair, Palakhal, Kachua, Chandpur,</span>
                      <span>Chittagong</span>
                      <span>New York, NY 10001</span>
                    </div>
                    <div className='actions'>
                      <Link to='/my-account/edit-billing-address'>EDIT ADDRESS</Link>
                    </div>
                  </div>
                  
                  <div className='address'>
                    <div className='title'>Shipping address</div>
                    <div className='infos'>
                      <span>Forhad Hossain</span>
                      <span>MangoQuiz</span>
                      <span>Patwary Bari, Meghdair, Palakhal, Kachua, Chandpur,</span>
                      <span>Chittagong</span>
                      <span>New York, NY 10001</span>
                    </div>
                    <div className='actions'>
                      <Link to='/my-account/edit-shipping-address'>EDIT ADDRESS</Link>
                    </div>
                  </div>
                </div>
              </section>
              :
              props.page === 'account-details' ?
              <section className='account_details'>
                <PageTransition />
                <div className='section_title'><span className='fas fa-user'></span> Account details</div>
                <p>Press enter to save the changes.</p>
                <form className='account_details_form default'>
                  <div className='inputs'>
                    <div className='input_group'>
                      <div className='input_container'>
                        <label>First name</label>
                        <input type='text' value='Forhad' placeholder='First name' />
                      </div>
    
                      <div className='input_container'>
                        <label>Last name</label>
                        <input type='text' value='Hossain' placeholder='Last name' />
                      </div>
                    </div>
  
                    <div className='input_container'>
                      <label>Display name</label>
                      <input type='text' value='forhadhossain60' placeholder='Display name' />
                    </div>
  
                    <div className='input_container'>
                      <label>Email <a  onClick={() => {setEmailChangeFormShow(!emailChangeFormShow)}}>Change Email</a></label>
                      <input type='text' value='forhadhossain60@outlook.com' placeholder='Email' disabled />
                    </div>
  
                    <div className='input_container'>
                      <label>Mobile Number</label>
                      <input type='text' value='01724904320' placeholder='Mobile Number' />
                    </div>
                  </div>
                </form>
  
                {
                  emailChangeFormShow ?
                  <form className='email_change_form default'>
                    <div className='form_header'>
                      <div className='title'>Change Email</div>
                    </div>
                    <div className='inputs'>
                      <div className='input_container'>
                        <label>New Email</label>
                        <input type='text' value='' placeholder='New Email' />
                      </div>
                      <div className='input_container'>
                        <label>Confirmation Code</label>
                        <input type='text' value='' placeholder='Confirmation Code' />
                      </div>
                    </div>
                    <div className='actions'>
                      <button className='submit_btn'>Change Email</button>
                    </div>
                  </form>
                  : <></>
                }
  
                <form className='password_change_form default'>
                  <div className='form_header'>
                    <div className='title'>Change Password</div>
                  </div>
                  <div className='inputs'>
                    <div className='input_container'>
                      <label for='current-password'>Current Password</label>
                      <input type='password' id='current-password' placeholder='Current Password' required />
                    </div>
                    <div className='input_container'>
                      <label for='new-password'>New Password</label>
                      <input type='password' id='new-password' placeholder='New Password' required />
                    </div>
                    <div className='input_container'>
                      <label for='confirm-password'>Confirm Password</label>
                      <input type='password' id='confirm-password' placeholder='Confirm Password' required />
                    </div>
                  </div>
                  <div className='actions'>
                    <button className='submit_btn'>Change Password</button>
                  </div>
                </form>
              </section>
              : props.page === 'edit_shipping_address'?
              <form className='edit_address_form default'>
                <PageTransition />
                <div className='form_header'>
                  <div className='title'>Edit Shipping Address</div>
                </div>
  
                <div className='inputs'>
                  <div className='input_container'>
                    <label>First name</label>
                    <input type='text' placeholder='Full name' />
                  </div>
                  
                  <div className='input_container'>
                    <label>Address</label>
                    <input type='text' placeholder='Address' />
                  </div>
                  <div className='input_container'>
                    <label>Country</label>
                    <input type='text' placeholder='Country' />
                  </div>
                  <div className='input_container'>
                    <label>State</label>
                    <input type='text' placeholder='State' />
                  </div>
                  <div className='input_container'>
                    <label>City</label>
                    <input type='text' placeholder='City' />
                  </div>
                  <div className='input_container'>
                    <label>Postal Code</label>
                    <input type='number' placeholder='Postal Code' />
                  </div>
                  <div className='input_container'>
                    <label>Phone Number</label>
                    <input type='tel' placeholder='Phone Number' />
                  </div>
                </div>
  
                <div className='actions'>
                  <button className='submit_btn'>Save Address</button>
                </div>
              </form>
            : props.page === 'edit_billing_address'?
              <form className='edit_address_form default'>
                <PageTransition />
                <div className='form_header'>
                  <div className='title'>Edit Billing Address</div>
                </div>
  
                <div className='inputs'>
                  <div className='input_container'>
                    <label>First name</label>
                    <input type='text' placeholder='Full name' />
                  </div>
                  
                  <div className='input_container'>
                    <label>Address</label>
                    <input type='text' placeholder='Address' />
                  </div>
                  <div className='input_container'>
                    <label>Country</label>
                    <input type='text' placeholder='Country' />
                  </div>
                  <div className='input_container'>
                    <label>State</label>
                    <input type='text' placeholder='State' />
                  </div>
                  <div className='input_container'>
                    <label>City</label>
                    <input type='text' placeholder='City' />
                  </div>
                  <div className='input_container'>
                    <label>Postal Code</label>
                    <input type='number' placeholder='Postal Code' />
                  </div>
                  <div className='input_container'>
                    <label>Phone Number</label>
                    <input type='tel' placeholder='Phone Number' />
                  </div>
                </div>
  
                <div className='actions'>
                  <button className='submit_btn'>Save Address</button>
                </div>
              </form>
            : <></>
            }
          </div>
        </div>
      </div>
    </div>
  )
}
